export var BranchToBranchInwardAPIKeys = {
    create: 'branchToBranchInwardCreate',
    update: 'branchToBranchInwardUpdate',
    get: 'branchToBranchInwardGetById',
    paging: 'branchToBranchInwardPaging',
    statusProgress: 'branchToBranchInwardStatusProgress',
    attachmentList: 'branchToBranchInwardAttachmentList',
    downloadAttachmentList: 'branchToBranchInwardDownloadAttachmentList',
    branchToBranchInwardPartList: 'branchToBranchInwardPartList',
    uploadAttachment: 'branchToBranchInwardUploadAttachment',
    deleteAttachment: 'branchToBranchInwardDeleteAttachment',
    AttachmentSystemName: 'InventoryInwardAttachment',
    RequisitionList: 'BToBRequisitionList'
};
export var BranchInwardApiKeys = [BranchToBranchInwardAPIKeys.paging];
export var showInwardColumnName = {
    DocumentCode: "Document Number",
    DocumentDate: "Inward Date",
    ReceivedOn: "Received Date",
    SourceBranchName: "Source Branch",
    DestinationBranchName: "Destination Branch",
    TotalReceivedQuantity: "Total Received Quantity",
    StatusName: "Status",
    TotalAmount: "Total Amount"
};
export var BranchToBranchInwardFields = {
    'ProductId': 'Product',
    'ReceivedQuantity': 'Received Quantity',
    'Condition': 'Condition'
};
export var BranchToBranchMandatoryInwardFields = {
    'ProductId': 'Product',
    'UOM': 'UOM',
    'AvailableQuantity': 'AvailableQuantity',
    'RequestedQuantity': 'RequestedQuantity',
    'ActualTransferredQuantity': 'ActualTransferredQuantity',
    'ActualReceivedQuantity': 'ActualReceivedQuantity'
};
